import React from "react";
import PropTypes from "prop-types";
import { Zap } from "lucide-react";

import EventPayrollAutoDeductionToggle from "./EventPayrollAutoDeductionToggle";

import { clx } from "../../../../../utils/Helpers";
import "./EventPayrollAutoDeduction.scss";

const EventPayrollAutoDeduction = ({
  labels,
  isMonthly,
  lateCheckInDeduction,
  autoCheckout,
  canEdit,
  disabled,
  onLateCheckInDeductionChange,
  onAutoCheckoutChange,
}) => {
  // Toggling is the only thing this section does — no edit permission, no section.
  if (!canEdit) return null;

  return (
  <div className="event-payroll-auto-deduction">
    <div className="event-payroll-auto-deduction__title">
      <Zap
        size={16}
        strokeWidth={1.3}
        className="event-payroll-auto-deduction__title-icon"
        aria-hidden
      />
      <span className="event-payroll-auto-deduction__title-text text-heading-sm">
        {labels.autoDeduction}
      </span>
    </div>
    <div
      className={clx(
        "event-payroll-auto-deduction__controls",
        !isMonthly && "event-payroll-auto-deduction__controls--single",
      )}
    >
      {isMonthly && (
        <>
          <EventPayrollAutoDeductionToggle
            variant="lateCheckIn"
            label={labels.lateCheckIn}
            checked={lateCheckInDeduction}
            disabled={disabled}
            onChange={onLateCheckInDeductionChange}
          />
          <span
            className="event-payroll-auto-deduction__divider"
            aria-hidden
          />
        </>
      )}
      <EventPayrollAutoDeductionToggle
        variant="autoCheckout"
        label={labels.autoCheckout}
        checked={autoCheckout}
        disabled={disabled}
        onChange={onAutoCheckoutChange}
      />
    </div>
  </div>
  );
};

EventPayrollAutoDeduction.propTypes = {
  labels: PropTypes.shape({
    autoDeduction: PropTypes.string.isRequired,
    lateCheckIn: PropTypes.string.isRequired,
    autoCheckout: PropTypes.string.isRequired,
  }).isRequired,
  isMonthly: PropTypes.bool.isRequired,
  lateCheckInDeduction: PropTypes.bool.isRequired,
  autoCheckout: PropTypes.bool.isRequired,
  canEdit: PropTypes.bool,
  disabled: PropTypes.bool,
  onLateCheckInDeductionChange: PropTypes.func.isRequired,
  onAutoCheckoutChange: PropTypes.func.isRequired,
};

EventPayrollAutoDeduction.defaultProps = {
  canEdit: true,
  disabled: false,
};

export default EventPayrollAutoDeduction;
